// src/pages/DashboardPage.js (Actualizado)
import React from 'react';
import { Typography, Container, Paper } from '@mui/material'; // <-- Corregido
import { useAuth } from '../context/AuthContext';

const DashboardPage = () => {
  const { user } = useAuth(); // Obtenemos la información del usuario logueado

  return (
    <Container>
      <Paper sx={{ padding: 3 }}>
        <Typography variant="h4" gutterBottom>
          Welcome to the Dashboard!
        </Typography>
        <Typography variant="body1">
          Hello, {user?.username || 'Admin'}. You are logged in for station {user?.station_id || ''}.
        </Typography>
        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
          Please select an option from the menu on the left to start managing your data.
        </Typography>
      </Paper>
    </Container>
  );
};

export default DashboardPage;
